// pages/KontaktPage.jsx
// Öffentliche Kontaktseite (/kontakt) im Stil der Veranstaltungsübersicht.
// Fragen zu einem bestimmten Turnier gehen an dessen Veranstalter; der Kontakt
// steht in jeder Ausschreibung. Alles Übrige an TDA.

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import { Icon, useThema, ThemaKnopf, OeffentlicherFuss } from '../components/oeffentlich/ausschreibungTeile';
import '../styles/ausschreibung.css';

const MAIL = 'info@tda-intl.com';

function Karte({ icon, titel, children }) {
  return (
    <section className="au-abschnitt au-kontakt-karte">
      <h2><Icon n={icon} />{titel}</h2>
      {children}
    </section>
  );
}

export default function KontaktPage() {
  const { thema, wirksam, umschalten } = useThema();
  useEffect(() => { document.title = 'Kontakt · TDA Tournament Center'; }, []);

  return (
    <div className="au" data-thema={thema || undefined}>
      <PublicNav />
      <div className="au-wrap au-kontakt">
        <div className="au-d-oben">
          <div>
            <h1 className="au-kontakt-titel">Kontakt</h1>
            <p className="au-kontakt-unter">Wir freuen uns auf deine Nachricht und antworten in der Regel innerhalb von 24 Stunden.</p>
          </div>
          <ThemaKnopf wirksam={wirksam} umschalten={umschalten} />
        </div>

        <div className="au-kontakt-raster">
          <Karte icon="post" titel="E-Mail">
            <p><a className="au-kontakt-mail" href={`mailto:${MAIL}`}>{MAIL}</a></p>
            <p className="au-kontakt-klein">Für Fragen zur Plattform, zu deinem Zugang, zu Rechnungen und zur Zusammenarbeit.</p>
          </Karte>

          <Karte icon="kal" titel="Fragen zu einem Turnier">
            <p>Startgeld, Kategorien, Zeitplan oder Ummeldungen klärt der Veranstalter des Turniers. Seine Kontaktdaten stehen in jeder Ausschreibung im Abschnitt „Kontakt“.</p>
            <p><Link to="/">Zu den Veranstaltungen</Link></p>
          </Karte>

          <Karte icon="haus" titel="Für Veranstalter">
            <p>Du möchtest selbst ein Turnier über TDA Events ausrichten? Hier findest du Ablauf, Leistungen und Preise.</p>
            <p><Link to="/fuer-veranstalter">Mehr für Veranstalter</Link></p>
          </Karte>

          <Karte icon="info" titel="Rechtliches">
            <p className="au-kontakt-links">
              <a href="https://tda-intl.org/impressum">Impressum</a>
              <a href="https://tda-intl.org/datenschutz">Datenschutz</a>
              <a href="https://tda-intl.org/agb.html">AGB</a>
            </p>
          </Karte>
        </div>
      </div>
      <OeffentlicherFuss />
    </div>
  );
}
